<template>
  <a-card :bordered="false">
    <a-table :columns="columns" :data-source="data">
      <template slot="footer">
        订单总数:xxxxx累计金额:xxx上次消费时间:xxxx
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { requestPost } from '@/api/api'

const columns = [
    {
        title: '订单名称',
        dataIndex: 'name',
        key: 'name'
    },
    {
        title: '订单号',
        dataIndex: 'age',
        key: 'age'
    },
    {
        title: '价格',
        dataIndex: 'price',
        key: 'price'
    }
]
export default {
    name: 'ModelDetail',
    props: {
        userid: {
            type: [Number, String],
            default: () => null
        }
    },
    data () {
        return {
            loading: false,
            data: null,
            columns
        }
    },
    mounted () {
        this.getLists()
    },
    methods: {
        /**
         * 获取列表
         *
         * @params
         */
        getLists () {
            this.loading = true
            console.log(this.$props.userid)
            const userid = this.$props.userid
            requestPost('/order/lists', userid)
                .then(res => {
                    const pagination = { ...this.pagination }
                    const { result } = res
                    pagination.total = result.paginate.total
                    pagination.pageSize = result.paginate.perpage
                    pagination.showTotal = function () {
                        return '共:' + result.paginate.total + '条数据'
                    }
                    this.price_sum = result.price_sum
                    this.list = result.data
                    this.pagination = pagination
                })
                .catch(err => {
                    this.$notification.error(err.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        /**
         * 提交按钮
         * form表单提交
         * @form
         */
        onOk () {
            return new Promise(resolve => {
                resolve(true)
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.ant-card-body {
    padding: 0;
}
</style>
